import { Box } from "@mui/material";
import { useMemo } from "react";
import NetworkTable from "../../../componentes/newEasyAdd/table";

const IP_REGEX =
  /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$|^(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}$/i;

const ipValidator = (value, callback) => {
  if (!value) {
    callback(true);
    return;
  }
  callback(IP_REGEX.test(value));
};

export default function CadastroTable(props) {
  const {
    hostsCadastrados,
    templates,
    setOpenEditHostModal,
    setEditingHostData,
    handleRequestDelete,
    proxys = [],
    buscarHost,
    loadingTable,
  } = props;

  const statusColumn = false;

  // Mapeamento de Proxys
  const { proxyNames, proxyMap } = useMemo(() => {
    const names = ["Sem Proxy"];
    const map = { 0: "Sem Proxy" };

    if (Array.isArray(proxys)) {
      proxys.forEach((p) => {
        names.push(p.host);
        map[p.proxyid] = p.host;
      });
    }
    return { proxyNames: names, proxyMap: map };
  }, [proxys]);

  // --- LÓGICA DE FILTRO E PREPARAÇÃO DOS DADOS ---
  const rowsForDisplay = useMemo(() => {
    // 1. Primeiro mapeamos os dados para o formato de exibição (ex: resolvendo nome do Proxy)
    const mappedRows = hostsCadastrados?.map((host) => {
      const proxyId = host.proxy || "0";
      const proxyDisplayName =
        proxyMap[proxyId] || (proxyId === "0" ? "Sem Proxy" : proxyId);

      return {
        ...host,
        proxy: proxyDisplayName,
      };
    });

    // 2. Se não houver busca, retorna tudo
    if (!buscarHost) return mappedRows;

    // 3. Se houver busca, filtra pelas colunas solicitadas
    const searchLower = buscarHost.toLowerCase();

    return mappedRows.filter((row) => {
      // Helper para verificar se o valor contém a busca de forma segura
      const check = (val) =>
        val && String(val).toLowerCase().includes(searchLower);

      return (
        check(row.id) ||
        check(row.hostid) ||
        check(row.nome) || // Host
        check(row.ip) || // IP
        check(row.comunidade) || // Comunidade
        check(row.portaSnmp) || // Porta SNMP
        check(row.fabricante) || // Fabricante
        check(row.modelo) || // Modelo
        check(row.userSsh) || // User SSH
        check(row.senhaSsh) || // Senha SSH
        check(row.portaSsh) || // Porta SSH
        check(row.proxy)
      );
    });
  }, [hostsCadastrados, proxyMap, buscarHost]); // Adicionado buscarHost nas dependências

  const { manufacturerList, equipmentMap } = useMemo(() => {
    const map = {};
    const list = [];
    if (Array.isArray(templates)) {
      templates.forEach((item) => {
        const key = item?.fabricante;
        if (key) {
          list.push(key);
          map[key] = item?.Funcoes.flatMap((f) =>
            f.Modelos.map((m) => `${f.funcao} - ${m.modelo}`),
          );
        }
      });
    }
    return { manufacturerList: list, equipmentMap: map };
  }, [templates]);

  const tableColumns = useMemo(() => {
    const cols = [
      { data: "nome", type: "text", width: 150 },
      { data: "ip", validator: ipValidator, width: 120 },
      { data: "checks.ping", readOnly: true, focusable: false, width: 70 }, // Nova coluna Ping
      { data: "checks.snmp", readOnly: true, focusable: false, width: 70 }, // Nova coluna SNMP
      { data: "comunidade", type: "text" },
      { data: "portaSnmp", type: "text", width: 90 },
      {
        data: "fabricante",
        type: "dropdown",
        source: manufacturerList,
        width: 130,
      },
      { data: "modelo", type: "dropdown", source: [], width: 130 },
      { data: "userSsh", type: "text", width: 100 },
      { data: "senhaSsh", type: "text", width: 80 },
      { data: "portaSsh", type: "text", width: 100 },
      { data: "proxy", type: "dropdown", source: proxyNames, width: 130 },
    ];

    if (statusColumn) {
      cols.push({
        data: "error_msg",
        type: "text",
        width: 100,
        wordWrap: true,
      });
    }
    cols.push({
      data: "actions",
      readOnly: true,
      focusable: false,
      width: 80,
      className: "htCenter",
    });

    return cols;
  }, [statusColumn, manufacturerList, proxyNames]); // Adicionado proxyNames

  const handleEditRow = (rowData) => {
    setEditingHostData(rowData);
    setOpenEditHostModal(true);
  };

  const handleDeleteRow = (rowData) => {
    const idToDelete = rowData.id || rowData.hostid || rowData.hostId;
    handleRequestDelete(idToDelete);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <NetworkTable
        rows={rowsForDisplay}
        columns={tableColumns}
        equipmentMap={equipmentMap}
        onEditRow={handleEditRow}
        onDeleteRow={handleDeleteRow}
        loadingTable={loadingTable}
      />
    </Box>
  );
}
